<template>
  <v-dialog v-model="dialog" :max-width="$vuetify.breakpoint.xsOnly ? '' : '600'" :fullscreen="$vuetify.breakpoint.xsOnly" persistent>
    <v-card v-if="quotation">
      <v-toolbar dark color="primary" flat>
        <v-toolbar-title>{{ detach ? $t('quotations.move.detach_title') : $t('quotations.move.title') }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark :title="$t('close')" :disabled="busy" @click="dialog = false"><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text class="pt-5 gradient-icons">
        <template v-if="detach">
          <div class="body-2 mb-4">{{ $t('quotations.move.detach_help') }}</div>
          <v-text-field v-model="name" :label="`${$t('quotations.name')} *`" outlined dense hide-details>
            <template v-slot:prepend><v-icon>mdi-folder-outline</v-icon></template>
          </v-text-field>
        </template>
        <template v-else>
          <div class="body-2 mb-4">{{ $t('quotations.move.help') }}</div>
          <v-autocomplete
            v-model="targetId"
            :items="projects"
            :search-input.sync="search"
            :loading="searching"
            item-text="name"
            item-value="id"
            :label="$t('quotations.move.target')"
            :no-data-text="$t('quotations.move.no_projects')"
            no-filter
            outlined
            dense
            hide-details
          >
            <template v-slot:prepend><v-icon>mdi-folder-search-outline</v-icon></template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
                <v-list-item-subtitle>{{ offersText(item) }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
          <div v-if="emptiesProject" class="caption grey--text mt-3">{{ $t('quotations.move.project_removed', { name: quotation.name }) }}</div>
        </template>
      </v-card-text>
      <v-divider />
      <v-card-actions :class="$vuetify.breakpoint.xsOnly && 'flex-column-reverse'">
        <v-spacer />
        <v-btn :block="$vuetify.breakpoint.xsOnly" text :disabled="busy" @click="dialog = false">{{ $t('cancel') }}</v-btn>
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          :class="$vuetify.breakpoint.xsOnly && 'mb-2'"
          color="primary"
          :loading="busy"
          :disabled="detach ? !name || !name.trim() : !targetId"
          @click="confirm"
        >
          {{ detach ? $t('quotations.move.detach') : $t('quotations.move.move') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import debounce from 'lodash.debounce';
import quotationApi from '@/api/quotation';

// Tarjouksen siirto toiseen tarjottavaan projektiin tai irrotus omaksi projektikseen (väärän yhdistämisen peruminen)
export default {
  name: 'MoveQuotationDialog',
  data() {
    return {
      dialog: false,
      detach: false,
      busy: false,
      quotation: null,
      name: '',
      search: null,
      searching: false,
      projects: [],
      targetId: null,
    };
  },
  computed: {
    emptiesProject() {
      return !!this.targetId && this.quotation.siblings.length === 0;
    },
  },
  watch: {
    search(value) {
      if (!this.detach && this.dialog) this.debounceSearch(value);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchProjects, 300);
  },
  methods: {
    open(quotation, { detach = false } = {}) {
      this.quotation = quotation;
      this.detach = detach;
      this.name = quotation.name;
      this.targetId = null;
      this.projects = [];
      this.search = null;
      this.dialog = true;
      if (!detach) this.searchProjects('');
    },
    async searchProjects(value) {
      this.searching = true;
      try {
        const projects = await quotationApi.searchProjects(value || '');
        this.projects = projects.filter(p => p.id !== this.quotation.offerProjectId);
      } catch (error) {
        this.$handleApiError(error);
      }
      this.searching = false;
    },
    offersText(project) {
      return project.offers.map(o => [o.code, o.partyName].filter(Boolean).join(' ')).join(', ');
    },
    async confirm() {
      this.busy = true;
      try {
        const updated = this.detach
          ? await quotationApi.detachQuotation(this.quotation.id, this.name.trim())
          : await quotationApi.moveQuotation(this.quotation.id, this.targetId);
        this.$emit('moved', updated);
        this.dialog = false;
      } catch (error) {
        this.$handleApiError(error, error && error.message);
      }
      this.busy = false;
    },
  },
};
</script>
